module.exports = __webpack_public_path__ + "img/rv-dump-stations-no.0d81e5fa.svg";